<template>
  <div class="w-100">
    <v-list nav density="compact" class="w-100 py-0">
      <draggable :list="localSteps" group="steps" :animation="200" @end="emitUpdate">
        <ui-list-item
          v-for="(step, index) in localSteps"
          :key="index"
          class="ui-card mb-1"
          icon="workflow"
          :title="'Stap ' + (index + 1) + ': ' + (step.header?.title || 'Geen titel')"
          arrow
          @click="editStep(index)"
        >
          <template #append>
            <v-icon
              class="text-danger"
              @click.stop="confirmDeleteDialog = true"
              size="20"
            >
              mdi-delete
            </v-icon>
          </template>
        </ui-list-item>
      </draggable>
    </v-list>

    <div class="text-right pt-1">
      <v-btn color="var(--primary)" @click="addStep" variant="text" class="btn btn-sm">
        <ui-icon name="plus" />
        Stap toevoegen
      </v-btn>
    </div>
    <v-dialog v-model="confirmDeleteDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title class="text-h6">Stap verwijderen</v-card-title>
        <v-card-text
          >Weet je zeker dat je deze stap wilt verwijderen? Deze actie kan niet ongedaan
          worden gemaakt.</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmDeleteDialog = false">Annuleer</v-btn>
          <v-btn color="error" text @click="deleteStep">Verwijderen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      class="dialog-right-drawer"
      transition="slide-x-reverse-transition"
      max-width="500px"
      scrollable
      persistent
    >
      <template #default>
        <v-slide-x-reverse-transition>
          <v-card color="#fff" class="canvas-background no-dots">
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Stap bewerken</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="saveStep" :loading="loading" color="white" variant="text"
                >Opslaan</v-btn
              >
            </v-toolbar>

            <v-card-text class="px-0">
              <settings-tabs v-model="setting_tab" v-if="editingStep">
                <template #general>
                  <v-divider class="my-4" />
                  <div class="text-right px-4 pb-2">
                    <v-btn
                      color="error"
                      variant="text"
                      @click="confirmDeleteDialog = true"
                    >
                      <v-icon start>mdi-delete</v-icon>
                      Stap verwijderen
                    </v-btn>
                  </div>
                  <v-row
                    class="mb-2"
                    v-if="editingStep.header?.icon || editingStep.header?.color"
                  >
                    <v-col cols="12">
                      <v-chip :color="editingStep.header.color || 'grey'" dark>
                        <v-icon left>{{ editingStep.header.icon || "mdi-help" }}</v-icon>
                        Preview
                      </v-chip>
                    </v-col>
                  </v-row>
                  <collapse-section :title="$t('step_header')" :open="true">
                    <k-field-group :name="$t('title')" labelsize="4">
                      <v-row dense>
                        <v-col cols="8">
                          <v-text-field
                            v-model="editingStep.header.title"
                            hide-details
                            variant="solo"
                            density="compact"
                          />
                        </v-col>
                        <v-col cols="4">
                          <ui-icon-picker v-model="editingStep.header.icon" />
                        </v-col>
                      </v-row>
                    </k-field-group>
                    <k-field-group :name="$t('meta')" labelsize="4">
                      <tip-tap-input v-model="editingStep.header.meta" :fields="fields" />
                    </k-field-group>

                    <k-field-group :name="$t('description')" labelsize="4">
                      <tip-tap-input
                        v-model="editingStep.header.description"
                        :fields="fields"
                      />
                    </k-field-group>
                    <k-field-group :name="$t('image')" labelsize="4">
                      <tip-tap-input
                        v-model="editingStep.header.image"
                        :fields="fields"
                      />
                    </k-field-group>
                  </collapse-section>

                  <collapse-section :title="$t('step_data')" :open="true">
                    <k-field-group :name="$t('title')" labelsize="4">
                      <tip-tap-input v-model="editingStep.data.title" :fields="fields" />
                    </k-field-group>

                    <k-field-group :name="$t('meta')" labelsize="4">
                      <tip-tap-input v-model="editingStep.data.meta" :fields="fields" />
                    </k-field-group>

                    <k-field-group :name="$t('description')" labelsize="4">
                      <tip-tap-input
                        v-model="editingStep.data.description"
                        :fields="fields"
                      />
                    </k-field-group>
                    <k-field-group :name="$t('image')" labelsize="4">
                      <tip-tap-input v-model="editingStep.data.image" :fields="fields" />
                    </k-field-group>
                  </collapse-section>
                </template>

                <template #options>
                  <collapse-section :title="$t('options')" :open="true">
                    <k-field-group :name="$t('login_required')" labelsize="7">
                      <div class="ml-auto">
                        <v-switch
                          v-model="editingStep.login_required"
                          color="var(--primary)"
                          hide-details
                          :false-value="0"
                          :true-value="1"
                          inset
                        ></v-switch>
                      </div>
                    </k-field-group>
                  </collapse-section>

                  <!-- <collapse-section v-if="editingStep.screentype === 'form'" :title="$t('submit_actions')" :open="true">
                <k-field-group name="" labelsize="12" labelcolclass="py-0">
                  <ui-actions-repeater v-model="editingStep.data.custom_actions"
                    v-model:actions="editingStep.data.custom_actions" />
                </k-field-group>
              </collapse-section> -->
                  <collapse-section :title="$t('conditions')" :open="true">
                    <k-field-group
                      name=""
                      info="Stel in voor wanneer deze widget getoond mag worden."
                      labelcolclass="py-0"
                      labelsize="12"
                    >
                      <visibility v-model="editingStep.visibility" :fields="fields" />
                    </k-field-group>
                  </collapse-section>
                </template>
              </settings-tabs>
            </v-card-text>
          </v-card>
        </v-slide-x-reverse-transition>
      </template>
    </v-dialog>
  </div>
</template>

<script>
  import { VueDraggableNext as draggable } from "vue-draggable-next";

  export default {
    name: "FormStepRepeater",

    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
    },

    components: {
      draggable,
    },

    data() {
      return {
        setting_tab: "general",
        localSteps: [],
        dialog: false,
        editingIndex: null,
        editingStep: {},
        loading: false,
        confirmDeleteDialog: false,
        updatingInternally: false,
      };
    },

    watch: {
      modelValue: {
        immediate: true,
        handler(val) {
          const newVal = JSON.stringify(val);
          const currentVal = JSON.stringify(this.localSteps);
          if (newVal !== currentVal) {
            this.localSteps = JSON.parse(newVal);
          }
        },
      },
      localSteps: {
        deep: true,
        handler(newVal) {
          if (!this.updatingInternally) {
            this.$emit("update:modelValue", newVal);
          }
        },
      },
    },

    methods: {
      emitUpdate() {
        this.$emit("update:modelValue", [...this.localSteps]);
      },
      addStep() {
        this.editingStep = {
          number: this.localSteps.length + 1,
          login_required: 0,
          visibility: "",
          header: {
            title: "",
            meta: "",
            description: "",
            image: "",
          },
          data: {
            title: "",
            meta: "",
            description: "",
            image: "",
            fields: [],
          },
        };
        this.editingIndex = this.localSteps.length;
        this.dialog = true;
      },

      editStep(index) {
        this.editingStep = JSON.parse(JSON.stringify(this.localSteps[index]));
        this.editingIndex = index;
        this.dialog = true;
      },
      deleteStep() {
        if (this.editingIndex !== null) {
          this.localSteps.splice(this.editingIndex, 1);
          this.emitUpdate();
        }
        this.confirmDeleteDialog = false;
        this.dialog = false;
      },

      saveStep(close = true) {
        this.loading = true;

        const current = JSON.stringify(this.localSteps[this.editingIndex]);
        const updated = JSON.stringify(this.editingStep);

        if (current !== updated) {
          this.updatingInternally = true;
          this.localSteps.splice(this.editingIndex, 1, { ...this.editingStep });
          this.updatingInternally = false;
          this.emitUpdate();
        }

        this.loading = false;
        if (close) this.dialog = false;
      },
    },
  };
</script>
